

















































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { apiTransferRecordDetail } from '@/api/staff'

@Component
export default class TransferRecordDetail extends Vue {
    detail: any = {}
    operationLogs: any[] = []
    loading = false

    getTransferRecordDetail () {
      this.loading = true
      apiTransferRecordDetail({ id: this.$route.query.id }).then((res: any) => {
        this.detail = res || {}

        // 模拟操作记录数据
        this.operationLogs = [
          {
            create_time: this.detail.create_time,
            action: '发起转单',
            operator: this.detail.from_staff_name,
            remark: this.detail.transfer_reason
          },
          ...(this.detail.accept_time ? [{
            create_time: this.detail.accept_time,
            action: '接受转单',
            operator: this.detail.to_staff_name,
            remark: ''
          }] : [])
        ]
      }).finally(() => {
        this.loading = false
      })
    }

    handleEdit () {
      // 编辑转单记录
      this.$router.push({ path: '/staff/transfer-record/edit', query: { id: this.$route.query.id } })
    }

    handleApprove () {
      this.$confirm('确定要通过该转单吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.$message.success('转单已通过')
        this.getTransferRecordDetail()
      })
    }

    handleReject () {
      this.$prompt('请输入驳回原因', '驳回转单', {
        inputPlaceholder: '请输入驳回原因',
        inputPattern: /.+/,
        inputErrorMessage: '驳回原因不能为空'
      }).then((result: any) => {
        const value = result?.value
        if (value) {
          this.$message.success('转单已驳回')
          this.getTransferRecordDetail()
        }
      }).catch(() => {
        // 用户取消
      })
    }

    handleExport () {
      // 导出功能
      this.$message.info('导出功能待实现')
    }

    formatDate (timestamp: number): string {
      if (!timestamp) {
        return '-'
      }
      const date = new Date(timestamp * 1000)
      return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`
    }

    formatDateTime (timestamp: number): string {
      if (!timestamp) {
        return '-'
      }
      const date = new Date(timestamp * 1000)
      return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
    }

    formatCurrency (value: number): string {
      if (!value) {
        return '￥0.00'
      }
      return '￥' + Number(value).toFixed(2)
    }

    getTransferTypeText (type: number): string {
      const typeMap = ['', '主动转单', '系统转单', '紧急转单', '临时转单']
      return typeMap[type] || '未知'
    }

    getTransferTypeTagType (type: number): string {
      const typeMap = ['', 'primary', 'info', 'warning', 'success']
      return typeMap[type] || ''
    }

    getTransferStatusText (status: number): string {
      const statusMap = ['', '已发起', '已接受', '已拒绝', '已取消', '已完成']
      return statusMap[status] || '未知'
    }

    getTransferStatusTagType (status: number): string {
      const typeMap = ['', 'info', 'success', 'danger', 'warning', 'primary']
      return typeMap[status] || ''
    }

    getFeePayerText (payer: number): string {
      const payerMap = ['', '转出方', '转入方', '公司承担', '共同承担']
      return payerMap[payer] || '未知'
    }

    getSettlementText (settlement: number): string {
      const settlementMap = ['', '原员工结算', '新员工结算', '比例分配']
      return settlementMap[settlement] || '未知'
    }

    getTempPaymentStatusText (status: number): string {
      const statusMap = ['', '未结算', '已结算', '部分结算']
      return statusMap[status] || '未知'
    }

    getTempPaymentStatusTagType (status: number): string {
      const typeMap = ['', 'warning', 'success', 'info']
      return typeMap[status] || ''
    }

    getOrderTypeText (type: number): string {
      const typeMap = ['', '保洁工单', '维修工单', '安保工单', '接待工单', '入住检查', '退房检查', '设备巡检', '绿化维护']
      return typeMap[type] || '未知'
    }

    getUrgencyText (level: number): string {
      const levelMap = ['', '普通', '紧急', '加急']
      return levelMap[level] || '未知'
    }

    getUrgencyTagType (level: number): string {
      const typeMap = ['', 'info', 'warning', 'danger']
      return typeMap[level] || ''
    }

    getOrderStatusText (status: number): string {
      const statusMap = ['', '待指派', '已指派', '进行中', '已完成', '已验收', '已取消', '已转单', '需补差价']
      return statusMap[status] || '未知'
    }

    getOrderStatusTagType (status: number): string {
      const typeMap = ['', 'warning', 'info', 'primary', 'success', 'success', 'danger', 'info', 'warning']
      return typeMap[status] || ''
    }

    created () {
      this.getTransferRecordDetail()
    }
}
